import axios from "axios";
import { baseURL } from "../config/api";

export const checkEmail = (email: string) => {
    return axios({
        url: `${baseURL}users/check-email`,
        method: "GET",
        params: {
            email,
        },
    }).then((response) => response.data);
};